module.exports = __webpack_public_path__ + "f1712ca0fc8a2f359b94f44720be5f50.svg";